/* Testi dei banner rate, riscritti piu' corti per stare su una riga.
   Gira dopo dema-price.js e riscrive solo le note: i calcoli restano
   quelli di DemaRate, che sono verificati sui casi reali. */
(function(){
"use strict";
function accorcia(){
 var box=document.getElementById("demaRate");
 if(!box||!window.DemaRate)return;

 var k=box.querySelector(".drt.klarna");
 if(k){
  var nota=k.querySelector(".sub");
  if(nota){
   var t=nota.textContent||"";
   var alt=(t.match(/12 rate da ([^,\.]+)/)||[])[1];
   if(alt)nota.innerHTML='oppure <b>12 rate da '+alt.trim()+'</b>';
  }
  var leg=k.querySelector(".fine");
  if(leg)leg.textContent="TAEG 0% a 3 rate \u00b7 17,60% a 12 rate";
 }

 var y=box.querySelector(".drt.younited");
 if(y){
  var n2=y.querySelector(".sub");
  if(n2)n2.innerHTML='altre durate al checkout';
  var l2=y.querySelector(".fine");
  if(l2){
   var s=l2.textContent||"";
   var es=(s.match(/Esempio su ([^\.]+)/)||[])[1];
   l2.textContent="TAN 12,28% \u00b7 TAEG 12,99%"+(es?" su "+es.trim():"");
  }
 }
}
addEventListener("load",accorcia);
setInterval(accorcia,700);
})();
